<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import PokerRunEventDataService from "@/services/PokerRunEventDataService";
import { PokerRunEvent } from "@models/PokerRunEvent";
import EventListItem from "@/components/EventListItem.vue";
import { useUserProfileStore } from "@/store/UserProfile";
import useDate from "@/modules/useDate";

const { getDate, formatISODate } = useDate();
const router = useRouter();
const userProfileStore = useUserProfileStore();
const recentPokerRuns = ref<PokerRunEvent[] | null>(null);

const openPastItem = (pokerRun: PokerRunEvent) => {
  router.push({ name: "PastEvent", params: { id: pokerRun.id } });
};

const initalize = async () => {
  const items = await PokerRunEventDataService.getUserPokerRuns(
    userProfileStore.profile.id
  );

  const today = formatISODate(new Date());

  recentPokerRuns.value = items.filter((x) => x.eventDate < today);
  recentPokerRuns.value.sort((a, b) => (a.eventDate > b.eventDate ? -1 : 1));
};
initalize();
</script>
<template>
  <AppEventContainer>
    <div>
      <div class="flex flex-col items-center justify-center" v-if="recentPokerRuns?.length === 0">
        <img class="p-3" src="@/assets/logo.png" alt="App logo" />
        <div class="m-5 font-semibold text-lg">You have no past events</div>
      </div>
      <div v-else>
        <AppSectionHeader class="mb-2">My Past Events</AppSectionHeader>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <template v-for="pokerRun in recentPokerRuns" :key="`recent-${pokerRun.id}`">
            <div>
              <EventListItem
                :poker-run-event="pokerRun"
                :show-type="true"
                v-on:click="openPastItem(pokerRun)"
              ></EventListItem>
            </div>
          </template>
        </div>
      </div>
    </div>
  </AppEventContainer>
</template>
